//////////////////
// Carousel Controller
// ------------
// Controller for .carousel objects across the site
//////////////////
App.Carousel = (function() {

	var carousels, carouselsCollection = [];
	var selectors = {
		carousels: ".carousel:not([data-carousel-ready]):not([data-flickity])"
		// carousels: ".carousel"
	};

	App.register(function() {
		App.log("Registered: App.Carousel");
		App.Carousel.renderCarousels();
	});

	return {
		/*
		Render all carousels in the page
		*/
		renderCarousels : function() {
			try {
				carousels = $(selectors.carousels);
				if(carousels.length) {
					$.each(carousels, function(i, element) {
						carouselsCollection.push(
							new Carousel(element)
						);
					});

				}
			} catch(e) {
				console.log("Error locating " + selectors.carousels, e);
			}
		},

		// Get a Carousel instance
		getCarousel : function (selector) {

			// If selector is an integer, then return Carousel at that position in collection
			if(Number.isInteger(selector)) {
				return(carouselsCollection[selector]);
			}

			// Otherwise assume it's a diff compare against the DOM element
			var c;
			$.each(carouselsCollection, function(i, item) {
				if(item.element == selector) {
					c = item;
				}
			});
			return(c || false);
		},

		// Add carousel to collection
		addCarousel : function (carousel) {
			carouselsCollection.push(carousel)
		}
	}

})();
